"use client";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";

export const ProtectedHeader = () => {
  const t = useTranslations("ProtectedHeader");
  let backButtonText = "";
  let backLink = "";
  const pathname = usePathname();

  switch (pathname) {
    case "/my-appointments": {
      backButtonText = t("myOrders");
      backLink = "/services/all";
      break;
    }
    case "/my-orders": {
      backButtonText = t("myOrders");
      backLink = "/";
      break;
    }
    default: {
      backButtonText = t("back");
      backLink = "/";
      break;
    }
  }

  return (
    <div
      className={[
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "z-20",
        "bg-white",
        "shadow-md",
        `${pathname === "/checkout" && "hidden sm:flex"}`,
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        <Link href={backLink}>
          <div
            className={["flex", "flex-row", "gap-3", "items-center"].join(" ")}
          >
            <ArrowLeftIcon />

            <p className="text-[20px] font-medium text-[#373737]">
              {backButtonText}
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
};
